/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import find from 'lodash/find'
import Config from '@/config'
import Graphql from '@/services/Graphql'
import Logger from '@/services/Logger'
import { graphqlManageError } from '@/helpers'
import routeTranslateKey from 'theme/i18n/routesI18n'

export function changeLanguageFromCurrentUrl (currentUrl, newLocale) {
  const regex = new RegExp(`/${Config.Theme.storeviewRegex}/`)
  if (currentUrl.match(regex)) {
    return currentUrl.replace(regex, `/${newLocale}/`)
  } else {
    return `/${newLocale}/`
  }
}

export function getLocalizedByName (name, locale = process.env.VUE_APP_STOREVIEWCODE, router) {
  const to = {
    name,
    params: {
      lang: locale
    }
  }
  return getLocalizedByParams(to, router)
}

export function getLocalizedByParams (to, router) {
  return router.resolve(to).href
}

export function externalCheckoutUrl (token, cartId, storeViewCode, externalCheckout = Config.Theme.externalCheckout) {
  token = token || ''
  return externalCheckout
    .replace('{{storeViewCode}}', storeViewCode)
    .replace('{{token}}', token)
    .replace('{{cartId}}', cartId)
}

export function urlResolve (url, ctx) {
  // cached call
  return Graphql.genericCallCash({
    token: ctx.store.state.user.token,
    storeViewCode: ctx.store.state.ui.storeViewCode,
    graphSchemaType: 'urlResolve',
    variables: { url }
  })
    .then(resp => {
      if (graphqlManageError(resp)) {
        // eslint-disable-next-line
        throw { body: { result: graphqlManageError(resp) } }
      }
      if (resp.data && resp.data.urlResolver === null) {
        // eslint-disable-next-line
        throw { body: { result: 'no results', url: url } }
      }
      return resp && resp.data ? resp.data.urlResolver : {}
    })
    .catch(err => {
      Logger.error(err)
      throw err
    })
}

export function getLocalizedByUrl (urlCode, url) {
  return `/${urlCode}/${url}`
}

export function isLookCategory (catId, ctx) {
  let categories = ctx.store.state.category.flatted
  let currentCategory = find(categories, { 'id': parseInt(catId) })
  // check if is a child
  if (currentCategory && currentCategory.custom_attributes && currentCategory.custom_attributes.length) {
    let attrToFind = find(currentCategory.custom_attributes, ['attribute_code', Config.customAttributes.category.lookCategory])
    if (attrToFind && attrToFind.value === 'looks') {
      return currentCategory
    }
  }
  return null
}

/**
 * require *url_key and *url_suffix
 * @param {product} param
 */
export function getProductUrl ({ product, store }) {
  let host = ''
  if (process.client) {
    host = location.origin
  }
  return host + getLocalizedByName('factoryPage', store.state.ui.urlCode, global.$router) + '/' + product.url_key + product.url_suffix
}

export function getUrl () {
  return process.client ? window.location.pathname : global.ctx.req.url
}

export function getStoreView (url) {
  let storeView = url.match(/\/(\w*)(\/)?/g)
  return storeView && storeView.length ? storeView[0].replace(/\//g, '') : ''
}

export function getLanguage (storeview) {
  if (storeview) {
    return storeview.split('_')[1]
  }
  return ''
}

export function pathTranslate ({ path }) {
  // get storeview from url
  let language = getLanguage(getStoreView(getUrl()))
  let existTranslate = routeTranslateKey[language] ? language : process.env.VUE_APP_I18N_FALLBACK_LOCALE
  return routeTranslateKey[existTranslate][path] || path
}

export function isProductUrl (url, ctx) {
  if (url && url.indexOf('/') !== -1) {
    // find in category path before
    let pathSplitted = url.split('/')
    let lastUrl = pathSplitted[pathSplitted.length - 1]
    let pathBefore = url.replace('/' + lastUrl, '')
    let pathFull = url.replace('.html', '')
    let parentCat = false
    let currentCat = false
    let categories = ctx.store.state.category.flatted
    for (let i in categories) {
      if (categories[i].url_path && categories[i].url_path === pathFull) {
        parentCat = currentCat = true
        break
      }
      if (categories[i].url_path && categories[i].url_path === pathBefore) {
        parentCat = true
      }
    }

    if (!currentCat && parentCat) {
      // get product path
      url = lastUrl
    }
  }
  return url
}
